/* eslint-disable */
import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import m from '@utils/strings';

class ExameNaoAutorizado extends Component {
    render() {
        let { exame } = this.props;
        let solicitacaoProcedimento = exame && exame.data && exame.data.SolicitacaoProcedimento? exame.data.SolicitacaoProcedimento : null;
        let motivosGlosa;
        solicitacaoProcedimento && solicitacaoProcedimento.ProcedimentoExames? 
            motivosGlosa = solicitacaoProcedimento.ProcedimentoExames.map((procedimento) => {
                let cod = procedimento.CodigoMotivoGlosa.replace(/([\a-zA-Z])/g,'');
                return (
                    <div className={"div-separador-top-10"}>
                        <label id={"descricao-erro-procedimento"}>
                            {cod} - {procedimento.DescricaoMotivoGlosa}
                        </label>
                    </div>
                );
            }) 
            : motivosGlosa = []; 
        return (
            <div>
                <div className={"div-area-resultado-autorizacao"} style={{ marginLeft: 50, marginTop: 40 }}>
                    <label id={"label-erro-servico"}>
                        {m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_ATENDIMENTO_NAO_AUTORIZADO}
                    </label>
                </div>
                {motivosGlosa.length > 0? motivosGlosa[0] : []}
                <div className={"div-separador-top-bottom-25"}>
                    <hr className={"hr-class"} style={{marginLeft: 101, marginRight: 458 }} />
                </div>
                <div className={"div-separador-top-10"}>
                    {<Button
                        onClick={() => {
                            this.props.resetAllStates();
                        }}
                        className={"btn-default-cemig"}
                        style={{ marginLeft: 115 }}
                        >
                        {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_NOVO_ATENDIMENTO} (ENTER)
                        </Button>}
                </div>
            </div>
        );
    }
}

export default ExameNaoAutorizado;
